var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgIconArticleNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.004-.004h18.008v18.008H-.004z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6 2.247v9.754M14.252 12.001v3.001M14.252 2.247a.75.75 0 0 1 .75.75v8.254a.75.75 0 0 1-.75.75H4.498a1.5 1.5 0 0 0-1.5 1.5h0a1.5 1.5 0 0 0 1.5 1.502M4.498 15.002H9M12.001 15.002h3.001"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 13.877h3.001v3.001l-1.5-.75-1.501.75zM2.998 13.502V3.748a1.5 1.5 0 0 1 1.5-1.5h9.754"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArticleNew);
export default __webpack_public_path__ + "static/media/icon-article-new.04c730266655fda11337243c69ee57b6.svg";
export { ForwardRef as ReactComponent };